import { cardRef, defineGameCard, onResolve, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
import { addGrowth, alliedPlants, hasTrait, healUnit, isLiveOnBoard, plannedUnitId, tableOf, } from './plant-helpers.js';
/**
 * Разросшиеся корни: выбранное своё Дерево всегда получает 1 Рост, а при
 * наличии другого своего Растения в локации ещё и восстанавливает 2 здоровья.
 */
export const OvergrownRootsCard = defineGameCard({
    id: 'overgrown_roots',
    gameplay: {
        type: 'SPELL',
        cost: 1,
        planning: planningTargets([
            targetStep('tree', unitTarget({
                side: 'ally',
                cardinality: { min: 1, max: 1 },
                where: ({ unit }) => unit.traits.includes('TREE'),
            })),
        ]),
    },
    presentation: {
        name: 'Разросшиеся корни',
        description: 'Выбранное ваше Дерево получает 1 Рост. Если рядом с ним есть другое ваше Растение, оно также восстанавливает 2 здоровья.',
        glyph: {
            colors: ['#10213A', '#3B5818', '#6E9430', '#4D2814', '#724A1C'],
            rows: [
                '....................',
                '....................',
                '.....1111...1111....',
                '....123321.122331...',
                '....1233321333321...',
                '.....12333233321....',
                '......112323221.....',
                '........113111......',
                '.........131........',
                '....44...121........',
                '......4.4354...44...',
                '...4...555355.4.....',
                '....4445545554....4.',
                '...4..44444444.444..',
                '.....4.4.4.4..4.....',
                '....4.4..4..4..4....',
                '...4..4.4.4..4..44..',
                '.....4..4.4..4......',
                '.......4...4..4.....',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onResolve({
            source: 'card_effect',
            dependencies: [cardRef('plant_growth')],
            run: (ctx) => {
                const treeId = plannedUnitId(ctx, 'tree');
                const tree = treeId === undefined ? null : ctx.q.instance(treeId);
                if (ctx.self === undefined || !isLiveOnBoard(tree)
                    || tree.controllerId !== ctx.self.controllerId
                    || !hasTrait(ctx, tree.id, 'TREE'))
                    return;
                const neighbours = alliedPlants(ctx, tree.controllerId, {
                    tableId: tableOf(tree.cellId),
                    exclude: new Set([tree.id]),
                });
                addGrowth(ctx, tree.id, 1, 'roots');
                if (neighbours.length >= 1)
                    healUnit(ctx, tree.id, 2, ctx.self.id);
            },
        }),
    ],
    ui: {
        mechanics: ['growth'],
        planning: { steps: { tree: { label: 'Выберите своё Дерево' } } },
    },
});
//# sourceMappingURL=overgrown_roots.js.map